import React from "react";
import PropTypes from "prop-types";
import { NavigatorAction, NavigatorStore } from "../../../flux";
import { Isvg } from "../../../components";

export default class ReadingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentReading: this.props.reading && this.props.reading.uuid
    };
  }

  _onClick(reading) {
    if (!this.props.loading) {
      if (typeof this.props.onReadingClicked === "function") {
        this.props.onReadingClicked(reading);
      }
      this.setState({ currentReading: reading.uuid });

      NavigatorAction.replace("assignment-reading", { reading });
    }
  }

  renderCompleted() {
    return (
      <div className="status complete">
        <p>{i18n.t("assignments.complete")}</p>
        <Isvg src="/img/checkmark_sm.svg" />
      </div>
    );
  }

  renderInProgress(reading) {
    if (reading) {
      if (this.state.currentReading === reading.uuid) {
        return (
          <div className="status in-progress">
            <p>{i18n.t("assignments.in-progress")}</p>
          </div>
        );
      }
    }
  }

  render() {
    return (
      <span>
        <ul id="reader-reading-list">
          {this.props.readings.map(reading => (
            <li
              className={
                this.state.currentReading === reading.uuid ? "selected" : ""
              }
              key={reading.uuid}
            >
              <button
                className="reading-desc noButton"
                onClick={this._onClick.bind(this, reading)}
              >
                <p>{reading.description}</p>
                {reading.completed_at
                  ? this.renderCompleted()
                  : this.renderInProgress(reading)}
              </button>
            </li>
          ))}
        </ul>
      </span>
    );
  }
}

ReadingList.propTypes = {
  readings: PropTypes.array.isRequired,
  reading: PropTypes.object,
  book: PropTypes.object.isRequired
};
